import React, { useState, VFCX } from 'react';
import styled from '@emotion/styled';
import { Drawer } from '@material-ui/core';

import DrawerContents from './drawer-contents';

const Component: VFCX = ({ className }) => {
  const [open, setOpen] = useState(false);

  const toggle = () => setOpen((currentState) => !currentState);

  return (
    <header className={className}>
      <div className='hamburger' onClick={toggle}>
        <span></span>
      </div>
      <Drawer anchor='right' open={open} onClose={toggle} className='drawer'>
        <DrawerContents toggleDrawer={toggle} />
      </Drawer>
    </header>
  );
};

const StyledComponent = styled(Component)`
  position: fixed;
  top: 0;
  right: 0;
  z-index: 100;

  & > .hamburger {
    position: relative;
    height: 60px;
    width: 60px;
    margin: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    &:before {
      position: absolute;
      content: '';
      z-index: -1;
      background: linear-gradient(217deg, var(--color-primary-light), #fff);
      width: 60px;
      height: 60px;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      border-radius: 63% 37% 54% 46% / 55% 48% 52% 45%;
    }

    & > span,
    & > span:before,
    & > span:after {
      content: '';
      display: block;
      height: 3px;
      width: 25px;
      border-radius: 3px;
      background-color: var(--color-primary-dark);
      position: absolute;
    }
    & > span:before {
      bottom: 8px;
    }
    & > span:after {
      top: 8px;
    }
  }

  @media only screen and (min-width: 1024px) {
  }

  @media only screen and (min-width: 768px) {
    background-color: transparent;
  }
`;

export default StyledComponent;
